export enum SafeguardTypeEnum {
    OSG = "OSG",
    PSG = "PSG",
    DSG = "DSG"
}

export enum OverspentSafeguardTypeEnum {
    OSG_LIMIT = "OSG_LIMIT",
    OSG_ALERT = "OSG_ALERT"
}

export enum PaymentSafeguardTypeEnum {
    PSG_LIMIT = "PSG_LIMIT",
    PSG_ALERT = "PSG_ALERT"
}

export enum DataSafeguardTypeEnum {
    DSG_LIMIT = "DSG_LIMIT",
    DSG_ALERT = "DSG_ALERT"
}